function UnsubscribeSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'member/unsubscribe';
  return $resource(odataUrl, {}, {
    put: { method: 'Put', params: { memberId: '@memberId', emailCategory: '@emailCategory' }, isArray: false }
  });
};

export default {
  name: "UnsubscribeSvc",
  fn: UnsubscribeSvc
} 